import useAppStore from "@/context/store";
import { createBoard } from "@/services";
import useRequest from "@/utils/useReq";
import { Button, Checkbox, Form, Input } from "antd";
import classNames from "classnames";
import { useCallback, useEffect, useRef, useState } from "react";
import { Else, If, Then, When } from "react-if";
import HBIcon from "../HBIcon";
import HBMessage from "../HBMessage";
import styles from "./index.module.less";

export default function CreateBoard({
  className,
  onCreate,
  useCreation,
  boardName,
  onlyCreation,
}) {
  const user = useAppStore((s) => s.user);
  const [edit, setEdit] = useState(false);
  const formRef = useRef(null);

  const showCreation = user?.extra?.is_museuser && useCreation;

  const { runAsync: runCreateBoard } = useRequest(createBoard, {
    manual: true,
  });

  const onEdit = useCallback(
    async (e) => {
      e.stopPropagation();
      if (boardName) {
        if (showCreation) {
          setEdit(true);
          setTimeout(() => {
            formRef.current?.setFieldsValue({
              title: boardName,
            });
          });
        } else {
          const result = await runCreateBoard({
            title: boardName,
          });

          if (!result.err) {
            HBMessage.success("创建画板成功");
            onCreate && onCreate(result?.board);
            useAppStore.getState().refreshLastBoards();
          }
        }
      } else {
        setEdit(true);
      }
    },
    [boardName, onCreate, runCreateBoard, showCreation]
  );

  const onCancel = useCallback(() => {
    setEdit(false);
  }, []);

  const onOk = useCallback(async () => {
    const values = formRef.current?.getFieldsValue(true) || null;

    if (!values?.title) {
      HBMessage.error("请输入画板名");
      return;
    }

    const result = await runCreateBoard({
      title: values?.title,
      ...(values?.creation || onlyCreation ? { creation: "true" } : null),
    });

    if (!result.err) {
      HBMessage.success("创建画板成功");
      useAppStore.getState().refreshLastBoards();
      setEdit(false);
      onCreate && onCreate(result?.board);
    }
  }, [onCreate, onlyCreation, runCreateBoard]);

  useEffect(() => {
    if (boardName) {
      setEdit(false);
    }
  }, [boardName]);

  return (
    <div className={classNames([styles.container, className])}>
      <If condition={edit}>
        <Then>
          <div className={classNames([styles.edit, "edit"])}>
            <div className={styles.wrapper}>
              <Form className={styles.form} layout="inline" ref={formRef}>
                <Form.Item name="title">
                  <Input
                    autoFocus
                    className={styles.input}
                    placeholder="画板名称"
                    onClick={(e) => e.stopPropagation()}
                  />
                </Form.Item>
                {showCreation && !onlyCreation ? (
                  <Form.Item name="creation" valuePropName="checked">
                    <Checkbox className={styles.checkbox}>原创画板</Checkbox>
                  </Form.Item>
                ) : null}
              </Form>
              <div className={styles.operation}>
                <Button
                  className={styles.cancel}
                  size="small"
                  onClick={onCancel}
                >
                  取消
                </Button>
                <Button
                  className={styles.ok}
                  size="small"
                  type="primary"
                  onClick={onOk}
                  data-gd-click="button_click"
                  data-button-name={
                    onlyCreation ? "确定创建原创画板" : "确定创建画板"
                  }
                >
                  确定
                </Button>
              </div>
            </div>
          </div>
        </Then>
        <Else>
          <div className={classNames([styles.buttonContainer, "button"])}>
            <div
              className={styles.button}
              onClick={onEdit}
              data-gd-click="button_click"
              data-button-name={onlyCreation ? "创建原创画板" : "创建画板"}
            >
              <HBIcon className={styles.icon} type="add" />
              <div className={styles.text}>
                {onlyCreation ? "创建原创画板" : "创建画板"}
              </div>
              <When condition={boardName}>
                <div className={styles.subtext}>{boardName}</div>
              </When>
            </div>
          </div>
        </Else>
      </If>
    </div>
  );
}
